import moment from "moment";
import Vue from "vue";
import { router } from "@/router";
import _ from "lodash";
import store from "@/store";
import FnBReportsService from "@/services/FnBReportsService";

function initialState() {
  return {
    ConcessionDailyReportExcelFileName: null,
    ConcessionDailyReportPDFFileName: null,
    dropDownObject: {
      fromDate: new Date(),
      toDate: new Date(),
      cinema_name: null,
      cinema_id: null,
      movie_id: null,
      movie_title: null,
      user_id: null,
      username: "",
    },
    ConcessionDailyExcelFileName: null,
    ConcessionDailyPdfFileName: null,
    ConcessionDailyReport: [],
    getFnbItemList: [],
    getConcessionFnbItemExcel: "",
    getConcessionFnbItemPdf: "",
    pdfrecord: "",
    excelrecord: "",
    grandTotalForConcessionsReport: {
      totalQuantity: 0,
      totalRevenue: 0,
      totalDiscount: 0,
      totalBalance: 0,
      totalCashCardAmount: 0,
      totalPaymentModeAmount: 0,
      totalCashAmount: 0,
    },
  };
}

const state = initialState();

const mutations = {
  SET_DROP_DOWN_VALUES: (state, payload) => {
    switch (payload.name) {
      case "isCinema":
        state.dropDownObject.cinema_id = payload["selectedItem"]
          ? payload.selectedItem.cine_id
          : null;
        state.dropDownObject.cinema_name = payload["selectedItem"]
          ? payload.selectedItem.cine_name
          : null;
        if (state.dropDownObject.cinema_id) {
          store.dispatch("fetchPosUsersList", {
            cinema_id: state.dropDownObject.cinema_id,
          });
        }
        break;
      case "MasterMovie":
        state.dropDownObject.movie_id = payload["selectedItem"]
          ? payload.selectedItem.movie_id
          : null;
        state.dropDownObject.movie_title = payload["selectedItem"]
          ? payload.selectedItem.movie_title
          : null;
        break;
      case "PosUser":
        state.dropDownObject.user_id = payload["selectedItem"]
          ? payload.selectedItem.user_id
          : null;
        state.dropDownObject.username = payload["selectedItem"]
          ? !payload.selectedItem.user_id
            ? "All"
            : `${payload.selectedItem.first_name} ${payload.selectedItem.middle_name} ${payload.selectedItem.last_name}`
          : null;
        break;
      default:
        console.log(
          "Advance Sales Report :( Sorry, we are enable to set value."
        );
    }
  },
  ON_RESET_CONCESSION_DAILY_REPORT_STORE_STATE: (state, payload) => {
    // state = initialState();
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
  SET_CONCESSION_DAILY_REPORT_DATES: (state, payload) => {
    // console.log('payload :', payload);
    payload["name"]
      ? (state.dropDownObject[payload.name] = payload["event"]
          ? payload.event
          : null)
      : "";
  },
  SET_DAILY_FNB_CONCESSION_REPORT_DATA: (state, payload) => {
    state.getFnbItemList = payload;
  },
  SET_FNB_ITEMS_CONCESSION_EXCEL: (state, payload) => {
    state.getConcessionFnbItemExcel = payload;
  },
  SET_FNB_ITEMS_CONCESSION_PDF: (state, payload) => {
    state.getConcessionFnbItemPdf = payload;
  },

  SET_DAILY_CONCESSION_REPORT_DATA: (state, payload) => {
    state.ConcessionDailyReport = payload;

    let grandTotalForConcessionsReport = {
      totalQuantity: 0,
      totalRevenue: 0,
      totalDiscount: 0,
      totalBalance: 0,
      totalNetAmount: 0,
      totalCashCardAmount: 0,
      totalPaymentModeAmount: 0,
      totalCashAmount: 0,
    };

    if (payload && Array.isArray(payload)) {
      payload.forEach((userObj) => {
        if (userObj.FnbItems && Array.isArray(userObj.FnbItems)) {
          userObj.FnbItems.forEach((item) => {
            if (item.paymentTypes && Array.isArray(item.paymentTypes)) {
              item.paymentTypes.forEach((paymentType) => {
                grandTotalForConcessionsReport.totalBalance +=
                  paymentType.balance_amount;
                grandTotalForConcessionsReport.totalDiscount +=
                  paymentType.ft_offer_price;
                grandTotalForConcessionsReport.totalRevenue +=
                  paymentType.total_amount;
                grandTotalForConcessionsReport.totalQuantity +=
                  paymentType.total_quantity;
                grandTotalForConcessionsReport.totalNetAmount +=
                  paymentType.net_amount;
                grandTotalForConcessionsReport.totalCashCardAmount +=
                  paymentType.cash_card_amount;
                grandTotalForConcessionsReport.totalPaymentModeAmount +=
                  paymentType.payment_mode_amount;
                grandTotalForConcessionsReport.totalCashAmount +=
                  paymentType.cash_amount;
              });
            }

            if (item.DataRefund && Array.isArray(item.DataRefund)) {
              item.DataRefund.forEach((refund) => {
                grandTotalForConcessionsReport.totalBalance -=
                  refund.total_refund;
                grandTotalForConcessionsReport.totalRevenue -=
                  refund.total_refund;
                grandTotalForConcessionsReport.totalQuantity -= refund.items;
                grandTotalForConcessionsReport.totalCashCardAmount -=
                  refund.cash_card_refund;
                grandTotalForConcessionsReport.totalPaymentModeAmount -=
                  refund.payment_mode_amount_refund;
                grandTotalForConcessionsReport.totalCashAmount -=
                  refund.cash_amount_refund;
              });
            }
          });
        }
      });
    }
    console.log(
      "grandTotalForConcessionsReport",
      grandTotalForConcessionsReport
    );

    state.grandTotalForConcessionsReport = grandTotalForConcessionsReport;
  },
  SET_DAILY_CONCESSION_EXCEL_FILE_NAME: (state, payload) => {
    state.ConcessionDailyExcelFileName = payload;
  },
  SET_DAILY_CONCESSION_PDF_FILE_NAME: (state, payload) => {
    state.ConcessionDailyPdfFileName = payload;
  },
};

const actions = {
  onConcessionDailyReportDropDownHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    await commit("SET_DROP_DOWN_VALUES", payload);
  },
  onConcessionDailyReportDateHandler: async (
    { dispatch, commit, state },
    payload
  ) => {
    commit("SET_CONCESSION_DAILY_REPORT_DATES", payload);
  },
  onResetConcessionDailyStoreState: async (
    { dispatch, commit, state },
    { ...payload }
  ) => {
    await commit("ON_RESET_CONCESSION_DAILY_REPORT_STORE_STATE");
  },
  onFetchDailyConcessionReport: async (
    { dispatch, commit, state },
    payload
  ) => {
    // console.log('object');
    let request_payload = {};

    console.log(
      "state.dropDownObject.cinema_id :",
      store.getters.getDailyReportSelectedObject
    );
    if (state.dropDownObject.cinema_id != null) {
      request_payload = state.dropDownObject;
    } else {
      request_payload = store.getters.getDailyReportSelectedObject;
    }
    console.log("request_payload :", request_payload);
    await commit("SET_DAILY_CONCESSION_REPORT_DATA", []);
    await commit("SET_DAILY_FNB_CONCESSION_REPORT_DATA", []);
    request_payload["fromDate"] = moment(request_payload["fromDate"]).format(
      "YYYY-MM-DD"
    );
    request_payload["toDate"] = moment(request_payload["toDate"]).format(
      "YYYY-MM-DD"
    );

    if (payload && payload.hasOwnProperty("OLD")) {
      request_payload["OLD"] = true;
    }
    if (request_payload.cinema_id != null) {
      let loader = Vue.$loading.show();
      await FnBReportsService.GetDailyConcessionReport(request_payload)
        .then(async (response) => {
          loader.hide();
          const { data } = response;
          console.log("data12 :>> ", data);
          if (data.status && data.Records.length > 0) {
            const deepClonedArr = _.cloneDeep(data.Records);
            deepClonedArr.forEach((x) => {
              x["newFnbItems"] = [];
              x.FnbItems.forEach((y) => {
                y.paymentTypes.forEach((z) => {
                  x.newFnbItems.push({ item_id: y.item_id, ...z });
                });
              });
            });
            console.log(deepClonedArr);
            commit("SET_DAILY_CONCESSION_REPORT_DATA", deepClonedArr);
            commit(
              "SET_DAILY_FNB_CONCESSION_REPORT_DATA",
              data.finalConcessionItem
            );
            commit(
              "SET_FNB_ITEMS_CONCESSION_EXCEL",
              data.finalFnbItemExcelpath
            );
            commit("SET_FNB_ITEMS_CONCESSION_PDF", data.finalFnbItemPdfPath);
            // await commit("SET_DAILY_FNB_CONCESSION_REPORT_DATA",data.);

            commit("SET_DAILY_CONCESSION_GRAND_TOTAL", deepClonedArr);

            await commit(
              "SET_DAILY_CONCESSION_EXCEL_FILE_NAME",
              data["ExcelName"] || null
            );
            await commit(
              "SET_DAILY_CONCESSION_PDF_FILE_NAME",
              data["PDFName"] || null
            );
          } else {
            Vue.toasted.show(data.message + " for Daily Concession data");
            // Vue.toasted.show(data.message);
          }
        })
        .catch((error) => {
          loader.hide();
          Vue.toasted.show(
            "Catch Error on FnBReportStore fetchCurrentStockReport",
            error
          );
        });
    } else {
      Vue.toasted.show("Please Select any Cinema.");
    }
  },
};

const getters = {
  getConcessionDailyReportsSelectedCinema: (state) =>
    state.dropDownObject.cinema_name,
  getConcessionDailyReportsSelectedMovie: (state) =>
    state.dropDownObject.movie_title,
  getConcessionDailyReportFromDate: (state) => state.dropDownObject.fromDate,
  getConcessionDailyReportToDate: (state) => state.dropDownObject.toDate,
  getConcessionDailyReportData: (state) => state.ConcessionDailyReport,
  getFnbItemList: (state) => state.getFnbItemList,
  getConcessionReportSelectedPosUser: (state) => state.dropDownObject.username,

  // Get File name
  getConcessionDailyExcelFileName: (state) =>
    state.ConcessionDailyExcelFileName,
  getConcessionDailyPdfFileName: (state) => state.ConcessionDailyPdfFileName,
  grandTotalForConcessionsReport: (state) =>
    state.grandTotalForConcessionsReport,
  getConcessionFnbItemExcel: (state) => state.getConcessionFnbItemExcel,
  getConcessionFnbItemPdf: (state) => state.getConcessionFnbItemPdf,
};

export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/ConcessionDailyReportStore.js